import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '../../../filters/translate.pipe';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
	standalone: true,
	selector: 'toolkit-library',
	templateUrl: './toolkit-library.component.html',
	imports: [CommonModule, FormsModule, TranslatePipe]
})
export class ToolkitLibraryComponent {
	@Input() vm: any;

	private readonly formatIcons: Record<string, string> = {
		psychoeducation:
			'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>',
		exercise:
			'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>',
		worksheet:
			'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>',
		'check-in':
			'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
		planner:
			'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>'
	};

	constructor(private readonly sanitizer: DomSanitizer) {}

	toolkit__resourceIcon(format?: string): SafeHtml {
		const key = (format || 'other').toString();
		const svg = this.formatIcons[key];
		if (svg) {
			return this.sanitizer.bypassSecurityTrustHtml(svg);
		}

		const labelFn = this.vm?.resourceFormatLabel;
		const label = typeof labelFn === 'function' ? labelFn(key) : null;
		const letter = (label || '?').toString().trim().charAt(0) || '?';
		return this.sanitizer.bypassSecurityTrustHtml(
			'<span class="toolkit__resourceIconFallback">' + letter.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</span>'
		);
	}
}
